// extracted by mini-css-extract-plugin
export default {"brandTogglerContainer":"DevelopmentBrandToggler_brandTogglerContainer__Om4Mk"};